import { Check } from "@phosphor-icons/react"
import { LinkButton } from "@tokenterminal/core/ui/button/LinkButton"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { Badge } from "@tokenterminal/core/ui/messaging/badge/Badge"
import { Fragment } from "react"
import MarketingHeading from "../../common/MarketingHeading"

const ProTierCallout = () => {
  const freeFeatures = [
    "Access dashboards for 1000s of projects",
    "Derive insights from prebuilt financial statements",
    "Try out Studio, Queries, and Sheets for free",
  ]

  const proFeatures = [
    "Download CSVs from any chart or screener table",
    "Create unlimited charts and dashboards in Studio",
    "Can run up to 30 TB of Queries in a month",
  ]

  const tiers = [
    {
      id: "free",
      title: "Get started for free",
      description: null,
      features: freeFeatures,
      cta: (
        <LinkButton className="w-full mt-4" size="large" href="/explorer">
          Get started for free
        </LinkButton>
      ),
    },
    {
      id: "pro",
      title: "Take the data with you",
      description: null,
      features: proFeatures,
      cta: (
        <LinkButton
          className="w-full mt-4"
          size="large"
          href="/pricing"
          color="success"
        >
          Subscribe to Pro
        </LinkButton>
      ),
    },
  ]

  return (
    <div className="max-w-[900px] mx-auto mt-72 mb-24">
      <div className="flex items-stretch gap-12 flex-col md:flex-row">
        {tiers.map((tier, index) => (
          <Fragment key={tier.id}>
            <div>
              <div className="flex flex-col gap-5">
                <div className="flex items-center gap-2">
                  {tier.id === "pro" && (
                    <Badge
                      color="green"
                      variant="solid"
                      size="small"
                      className="shrink-0"
                    >
                      PRO
                    </Badge>
                  )}
                  <MarketingHeading level={2} className="text-2xl">
                    {tier.title}
                  </MarketingHeading>
                </div>
                {tier.description && (
                  <div className="text-sm text-fg-secondary leading-[20px] mb-4">
                    {tier.description}
                  </div>
                )}
                <div className="flex flex-col gap-3">
                  {tier.features.map((feature) => (
                    <div
                      key={feature}
                      className="flex items-center justify-start gap-2"
                    >
                      <Icon as={Check} />
                      <div className="text-base text-fg-default">{feature}</div>
                    </div>
                  ))}
                </div>
                <div className="flex items-center justify-start gap-2">
                  {tier.cta}
                </div>
              </div>
            </div>
            {index === 0 && (
              <div
                className="border-l border-border-default"
                style={{
                  width: "1px",
                }}
              />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  )
}

export default ProTierCallout
